export default __webpack_public_path__ + "cc118b9607df6a6804445200181e751b.jpg";